import { Toast } from "primereact/toast";
import { FC, useEffect, useRef } from "react";
import {
  FormControl,
  FormGroup,
  useFormConfig,
  Validators,
  WForm,
  WFormControl,
} from "rectangular-forms";

import {
  inputMaxLengthFn,
  onlyDigits,
  WInputText,
} from "../../common/components/TemplateContainer/InputTemplates";
import { SaveButton } from "../../common/components/TemplateContainer/SaveButton";
import { TemplateInputContainer } from "../../common/components/TemplateContainer/TemplateContainer";
import IconVectorRightBlue from "../../images/icon_button_users_blue.svg";
import {
  ADDRESS_MAX_LENGTH,
  CONTACT_NAME_MAX_LENGTH,
  CONTACT_PHONE_NUMBER_MAX_LENGTH,
  EMAIL_MAX_LENGTH,
  PHONE_NUMBER_MAX_LENGTH,
  RUC_MAX_LENGTH,
  SUNARP_NUMBER_MAX_LENGTH,
} from "../../utils/valueStaticConstants";
import RequestedInput from "../RequestedInput/RequestedInput";
import {
  DivCompanyDirection,
  DivOverMaxHeigth,
  GrayBox,
} from "./UsersManagementAdminStyles";

interface IUsersManagementStepOneAdminForm {
  dataInitialCompany: {};
  onSuccess: (data: any) => void;
  setCheckInput: any;
  checkInput: any;
  valueInputCheck: any;
  errorLine: any;
  handleChange: (event) => void;
  loadRuc: any;
  dataUserEditAdmin: any;
}
const UsersManagementStepOneAdminForm: FC<IUsersManagementStepOneAdminForm> = (
  props
) => {
  const {
    dataInitialCompany,
    onSuccess,
    setCheckInput,
    checkInput,
    valueInputCheck,
    errorLine,
    handleChange,
    loadRuc,
    dataUserEditAdmin,
  } = props;
  const toast: any = useRef();
  const formConfig = useFormConfig({
    createForm: () => {
      const form = new FormGroup({
        address: new FormControl(null, [Validators.required]),
        phone_number: new FormControl(null, [
          Validators.required,
          Validators.maxLength(PHONE_NUMBER_MAX_LENGTH),
          Validators.pattern(/^[0-9]{7,15}$/),
        ]),
        sunarp_number: new FormControl(null, [Validators.required]),
        contact_name: new FormControl(null, [Validators.required]),
        email: new FormControl(null, [
          Validators.required,
          Validators.pattern(/^(.+)@(.+)\.(.+)$/),
        ]),
        contact_phone_number: new FormControl(null, [
          Validators.required,
          Validators.maxLength(PHONE_NUMBER_MAX_LENGTH),
          Validators.pattern(/^[0-9]{7,15}$/),
        ]),
      });
      return form;
    },
    onFormLoaded: (form, data) => {
      form.patchValue(data);
    },
    onSubmit: (form, { succeed }) => {
      if (form.invalid) {
        toast.current.show({
          severity: "error",
          summary:
            "Completar todos los campos obligatorios antes de continuar. ¡Gracias!",
          contentClassName: "",
        });
        return;
      }
      onSuccess(form.value);
      succeed(dataInitialCompany);
    },
  });

  const { loadSucceed } = formConfig;

  useEffect(() => {
    loadSucceed(dataInitialCompany);
  }, [dataInitialCompany, loadSucceed]);
  return (
    <DivOverMaxHeigth>
      <WForm
        formConfig={formConfig}
        globalErrorMessages={{
          minlength: (val) => {
            return `El valor tiene ${val.actualLength}. Valor mínimo requerido ${val.requiredLength}`;
          },
          maxlength: (val) => {
            return `Máximo Valor ${val.requiredLength}`;
          },
          required: "Campo requerido",
        }}
      >
        <Toast ref={toast}></Toast>
        <div className="p-grid" style={{ display: "flex" }}>
          <div style={{ paddingLeft: "0.5rem" }}>
            <h2>RUC:</h2>
            <RequestedInput
              disabled={dataUserEditAdmin}
              hasError={errorLine}
              width="16.4rem"
              height="5rem"
              value={valueInputCheck}
              onChangeValue={handleChange}
              placeholder="RUC"
              checked={checkInput}
              onChangeCheck={(ev) => {
                setCheckInput(ev.target.checked);
                if (!checkInput) {
                  loadRuc.execute({ valueInputCheck });
                }
              }}
              maxLength={RUC_MAX_LENGTH}
            />
          </div>
          <div style={{ marginLeft: "2rem" }}>
            <h2>Razón Social:</h2>
            <GrayBox width="34.8rem" height="5rem">
              {loadRuc.isSuccess && <span>{loadRuc.data.name}</span>}
              {dataUserEditAdmin && (
                <span>{dataUserEditAdmin.company.name}</span>
              )}
            </GrayBox>
          </div>
          <DivCompanyDirection
            className="p-md-2"
            width="25.6rem"
            marginLeft="2rem"
            marginTop="1rem"
          >
            <WFormControl name="address">
              <TemplateInputContainer label="Dirección Fiscal:">
                <WInputText
                  maxLength={ADDRESS_MAX_LENGTH}
                  onInput={inputMaxLengthFn}
                  width={"25.6rem"}
                  placeholder="Dirección fiscal"
                />
              </TemplateInputContainer>
            </WFormControl>
          </DivCompanyDirection>
          <DivCompanyDirection
            className="p-md-2"
            width="25.6rem"
            marginLeft="2rem"
            marginTop="1rem"
          >
            <WFormControl
              name="phone_number"
              errorMessages={{ pattern: "Ingrese datos correctos" }}
            >
              <TemplateInputContainer label="Teléfono:">
                <WInputText
                  onInput={inputMaxLengthFn}
                  maxLength={PHONE_NUMBER_MAX_LENGTH}
                  onKeyPress={onlyDigits}
                  width={"25.6rem"}
                  placeholder="Teléfono"
                />
              </TemplateInputContainer>
            </WFormControl>
          </DivCompanyDirection>
        </div>
        <div
          className="p-grid"
          style={{ display: "flex", marginTop: "3.2rem" }}
        >
          <div className="p-md-2" style={{ width: "25.6rem" }}>
            <WFormControl name="sunarp_number">
              <TemplateInputContainer label="Nro de partida SUNARP:">
                <WInputText
                  onKeyPress={onlyDigits}
                  width={"25.6rem"}
                  placeholder="Nro de partida SUNARP"
                  maxLength={SUNARP_NUMBER_MAX_LENGTH}
                  onInput={inputMaxLengthFn}
                />
              </TemplateInputContainer>
            </WFormControl>
          </div>
          <div
            className="p-md-2"
            style={{ width: "25.6rem", marginLeft: "2rem" }}
          >
            <WFormControl name="contact_name">
              <TemplateInputContainer label="Personal de contacto:">
                <WInputText
                  width={"25.6rem"}
                  placeholder="Personal de contacto"
                  maxLength={CONTACT_NAME_MAX_LENGTH}
                  onInput={inputMaxLengthFn}
                />
              </TemplateInputContainer>
            </WFormControl>
          </div>
          <div
            className="p-md-2"
            style={{ width: "25.6rem", marginLeft: "2rem" }}
          >
            <WFormControl
              name="email"
              errorMessages={{ pattern: "Email inválido" }}
            >
              <TemplateInputContainer label="Correo electrónico de contacto:">
                <WInputText
                  width={"25.6rem"}
                  placeholder="Correo electrónico de contacto"
                  maxLength={EMAIL_MAX_LENGTH}
                  onInput={inputMaxLengthFn}
                />
              </TemplateInputContainer>
            </WFormControl>
          </div>
          <div
            className="p-md-2"
            style={{ width: "25.6rem", marginLeft: "2rem" }}
          >
            <WFormControl
              name="contact_phone_number"
              errorMessages={{ pattern: "Ingrese datos correctos" }}
            >
              <TemplateInputContainer label="Celular de contacto:">
                <WInputText
                  width={"25.6rem"}
                  placeholder="Celular de contacto"
                  maxLength={CONTACT_PHONE_NUMBER_MAX_LENGTH}
                  onInput={inputMaxLengthFn}
                  onKeyPress={onlyDigits}
                />
              </TemplateInputContainer>
            </WFormControl>
          </div>
        </div>
        <div style={{ marginTop: 20 }}>
          <SaveButton
            isDisableRuc={!dataUserEditAdmin && !loadRuc.data}
            label="Siguiente"
            iconRight={IconVectorRightBlue}
            width="25.6rem"
            height="6rem"
            fontSize="1.6rem"
            backgroundColor="#88B13B"
          />
        </div>
      </WForm>
    </DivOverMaxHeigth>
  );
};

export default UsersManagementStepOneAdminForm;
